import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import {
  MyHrDataCard,
  MyHrPasswordCard,
  MyHrProfileImage,
  MyHrProfileRoles,
  MyHrUserTwoFactorCard,
} from "my-hr/components";
import { useMyHrContractsByEmployee, useMyHrUserByEmployee } from "my-hr/hooks";
import { OcPageTransition } from "oc/components";
import { useOcCurrentUserState, useOcIsMobile, useOcProperty } from "oc/hooks";

export const MyHRUserProfilePage = () => {
  const { t } = useTranslation();
  let { employeeCode } = useOcCurrentUserState();
  const { data: userData, refetch: refetchUserData } = useMyHrUserByEmployee({
    employee: employeeCode,
  });

  const { data: contractsData } = useMyHrContractsByEmployee({
    employee: employeeCode,
  });

  const { data: loginType } = useOcProperty({
    resource: "system",
    key: "loginType",
  });

  const isSSO = loginType && loginType === "sso" ? true : false;

  const isMobile = useOcIsMobile();

  return (
    <OcPageTransition>
      <Box>
        <Box
          height="80px"
          style={{ backgroundColor: "#cc0033" }}
          display="flex"
          flexDirection="row"
          alignItems="center"
          paddingLeft="14px"
        >
          <Box style={{ color: "white", fontSize: "24px" }}>
            {t("MY_HR_MY_PROFILE")}
          </Box>
        </Box>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>
          <Box
            width="240px"
            height="40px"
            display="flex"
            flexDirection="row"
            alignItems="center"
            style={{
              backgroundColor: "white",
              borderLeft: "4px solid #cc0033",
              paddingLeft: "40px",
            }}
          >
            <Box
              style={{
                fontSize: "14px",
                letterSpacing: "0.25px",
              }}
            >
              {t("MY_HR_USER_ACCOUNT")}
            </Box>
          </Box>
          <Box flexGrow={1} padding={isMobile ? "16px 0px" : "16px"}>
            <MyHrProfileImage
              employeeCode={employeeCode}
              isMobile={isMobile}
              loading={false}
              disabledNewRequest={false}
            />
            <Box height="16px" />
            <MyHrDataCard userData={userData} isMobile={isMobile} />
            <Box height="16px" />
            {!isSSO && (
              <MyHrPasswordCard email={userData?.email} isMobile={isMobile} />
            )}
            <Box height="16px" />
            <MyHrUserTwoFactorCard
              padding="0px 0px 16px 0px"
              userData={userData}
              refetchUserData={refetchUserData}
              isMobile={isMobile}
            />
            <MyHrProfileRoles contracts={contractsData} />
          </Box>
        </Box>
      </Box>
    </OcPageTransition>
  );
};

export default MyHRUserProfilePage;
